/**
 * Compares props to determine if the component needs to update
 * @param {Object} prevProps - Previous props
 * @param {Object} nextProps - New props
 * @returns {boolean} - True if props are equal, false if they need updating
 */

const arePropsEqual = (prevProps, nextProps) => {
  const { figures: prevFigures = [], pictures: prevPictures = [], bookmark: prevBookmark } = prevProps;
  const { figures: nextFigures = [], pictures: nextPictures = [], bookmark: nextBookmark } = nextProps;

  const hasBookmarkChanged = () => {
    if (!prevBookmark && !nextBookmark) {
      return false;
    }

    if (!prevBookmark || !nextBookmark) {
      return true;
    }

    return Object.keys(prevBookmark).some(key => prevBookmark[key] !== nextBookmark[key]);
  };

  if (
    prevFigures?.length !== nextFigures?.length ||
    prevPictures?.length !== nextPictures?.length ||
    hasBookmarkChanged()
  ) {
    return false;
  }

  const haveItemsChanged = (prev, next) =>
    prev.some((item, index) => {
      const nextItem = next[index];

      if (!item || !nextItem) {
        return true;
      }

      return item.id !== nextItem.id || item.src !== nextItem.src;
    });

  return !haveItemsChanged(prevFigures, nextFigures) && !haveItemsChanged(prevPictures, nextPictures);
};

export default arePropsEqual;
